module.exports = __webpack_public_path__ + "img/virtual-client-work.0d30770.png";